import { Handle, Position } from "reactflow";
import { MdCallMerge } from "react-icons/md";

const ParallelStartNode = ({ id, onClick }) => {
  return (
    <div>
      <Handle type="target" position={Position.Top} id={`TargetTop${id}`} />
      <Handle type="target" position={Position.Right} id={`TargetRight${id}`} />
      <MdCallMerge
        className="fs-2 rotate-180 text-white bg-orange rounded-circle"
        onClick={onClick}
      />
      <p className="parallel-name ms-2 fs-5">{id}</p>
      <Handle
        type="source"
        position={Position.Bottom}
        id={`SourceBottom${id}`}
      />
      <Handle type="target" position={Position.Left} id={`TargetLeft${id}`} />
    </div>
  );
};

export default ParallelStartNode;
